import React, { FC } from 'react';
import ReactGoogleLogin from 'react-google-login';
import { useDispatch } from 'react-redux';
import { history } from '../../history';
import { loginWithGoogle } from '../../services/authentication/AuthenticationService';
import { setCurrent } from '../../slices/user';
import { removeOrganizationId, setKreezeeSession } from '../../utilities/LocalStorage';
import { GoogleIcon } from '../icons/GoogleIcon';

interface Props {
  setError: (e: string) => void;
}

const GoogleLogin: FC<Props> = ({ setError }: Props) => {
  const dispatch = useDispatch();

  async function handleLoginGoogle(response) {
    try {
      setError('');
      const tokenId = response.tokenId;
      const result = await loginWithGoogle(tokenId, 'fr');
      if (result.data) {
        removeOrganizationId();
        setKreezeeSession(JSON.stringify({ jwt: result.data.jwt }));
        dispatch(setCurrent({ ...result.data, jwt: null }));
        history.push('/');
      } else {
        setError('GoogleLogin: error message');
      }
    } catch {
      setError('GoogleLogin: error message');
    }
  }
  return (
    <ReactGoogleLogin
      clientId={window.configs.googleClientId}
      buttonText=""
      onSuccess={handleLoginGoogle}
      onFailure={console.log}
      render={(prop) => (
        <div className="google-login" onClick={prop.onClick}>
          <GoogleIcon width={54} height={54} />
        </div>
      )}
    />
  );
};

export default GoogleLogin;
